/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const activateUserPathParamsSchema = z.object({
    "id": z.string().describe("Sidekick user id")
    })

/**
 * @description User activated
 */
export const activateUser201Schema = z.object({
    "id": z.string(),
"email": z.string(),
"name": z.string(),
"active": z.boolean(),
"monitoringEnabled": z.boolean(),
"maxContactsAllowed": z.int().min(-9007199254740991).max(9007199254740991),
"createdAt": z.iso.datetime()
    })

/**
 * @description User not found
 */
export const activateUser404Schema = z.any()

export const activateUserMutationResponseSchema = z.lazy(() => activateUser201Schema)